<script setup lang="ts">
import { useThemeStore } from "@/stores/themeStore";
import { config } from "@/lib/variantConfig";

const themeStore = useThemeStore();
</script>

<template>
  <img
    :src="
      themeStore.theme === 'dark'
        ? '/logo_sidebar_dark.svg'
        : '/logo_sidebar.svg'
    "
    :alt="config.strings.app_name"
  />
</template>
